const data = {
  name: "guest",
  uid: "guest",
  authType: null,
  accessToken: null,
};

export default data;
